export default __webpack_public_path__ + "i18n/ja.328f54b58c4f698c73f2819fedc82de2.json";